import OptimizerEditDto from './OptimizerEditDto';

export class RestartOptimizerEditDto extends OptimizerEditDto {
	constructor() {
		super();
		/** @type {number} */
		this.maxEpoch = null;
		/** @type {number} */
		this.localOptimizer = null;
	}

	/**
	 * @typedef {Object} _RestartOptimizerEditDtoProps
	 * @property {number} maxEpoch
	 * @property {number} localOptimizer
	 *
	 * @typedef {import("./OptimizerEditDto").OptimizerEditDtoProps & _RestartOptimizerEditDtoProps} RestartOptimizerEditDtoProps
	 */
	/**
	 *
	 * @param {RestartOptimizerEditDtoProps} props
	 * @returns {RestartOptimizerEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.maxEpoch = props.maxEpoch;
		this.localOptimizer = props.localOptimizer;
		return this;
	}
}

export default RestartOptimizerEditDto;
